import { CardActions, Stack, styled, Typography } from '@mui/material';
import { Form, required, useNotify, useTranslate } from 'ra-core';
import { useResetPassword } from 'ra-supabase-core';
import { SaveButton, TextInput } from 'ra-ui-materialui';
import * as React from 'react';
/**
 * A component that renders a form for resetting the user password.
 */
export var ForgotPasswordForm = function () {
    var notify = useNotify();
    var translate = useTranslate();
    var resetPassword = useResetPassword({
        onError: function (error) {
            notify(typeof error === 'string'
                ? error
                : typeof error === 'undefined' || !error.message
                    ? 'ra.auth.sign_in_error'
                    : error.message, {
                type: 'warning',
                messageArgs: {
                    _: typeof error === 'string'
                        ? error
                        : error && error.message
                            ? error.message
                            : undefined,
                },
            });
        },
    })[0];
    var submit = function (values) {
        return resetPassword({
            email: values.email,
        });
    };
    return (React.createElement(Root, { onSubmit: submit },
        React.createElement("div", { className: SupabaseLoginFormClasses.container },
            React.createElement(Stack, { spacing: 1 },
                React.createElement(Typography, { variant: "h1", fontSize: "150%" }, translate('ra-supabase.reset_password.forgot_password', {
                    _: 'Forgot password',
                })),
                React.createElement(Typography, { variant: "body2", color: "GrayText" }, translate('ra-supabase.reset_password.forgot_password_details', {
                    _: 'Enter your email to receive a reset password link.',
                }))),
            React.createElement("div", { className: SupabaseLoginFormClasses.input },
                React.createElement(TextInput, { source: "email", label: translate('ra.auth.email', {
                        _: 'Email',
                    }), autoComplete: "email", fullWidth: true, validate: required() }))),
        React.createElement(CardActions, null,
            React.createElement(SaveButton, { variant: "contained", type: "submit", className: SupabaseLoginFormClasses.button, label: translate('ra.action.reset_password', {
                    _: 'Reset password',
                }), icon: React.createElement(React.Fragment, null) }))));
};
var PREFIX = 'RaSupabaseForgotPasswordForm';
var SupabaseLoginFormClasses = {
    container: "".concat(PREFIX, "-container"),
    input: "".concat(PREFIX, "-input"),
    button: "".concat(PREFIX, "-button"),
};
var Root = styled(Form, {
    name: PREFIX,
    overridesResolver: function (props, styles) { return styles.root; },
})(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b["& .".concat(SupabaseLoginFormClasses.container)] = {
            padding: '0 1em 1em 1em',
        },
        _b["& .".concat(SupabaseLoginFormClasses.input)] = {
            marginTop: '1em',
        },
        _b["& .".concat(SupabaseLoginFormClasses.button)] = {
            width: '100%',
        },
        _b);
});
